module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('table', {
    staticClass: "table is-narrow is-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.user.name) + " "), _c('em', {
    staticClass: "is-size-7"
  }, [_vm._v("(" + _vm._s(_vm.user.data.length) + " öl provade)")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.user.data.slice(0, _vm.itemsInList)), function(beer, beerIndex) {
    return _c('tr', {
      key: beerIndex
    }, [_c('td', [_c('v-link', {
      attrs: {
        "query": beer.name,
        "showTitle": "true"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "has-text-left top-favorite__rating"
    }, [_vm._v(_vm._s(beer.rating) + " "), _c('small', [_vm._v("(" + _vm._s(beer.average) + ")")])])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "has-text-right is-size-7 is-uppercase",
    attrs: {
      "colspan": "2"
    }
  }, [(_vm.user.data.length > 3) ? [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemsInList !== _vm.user.data.length),
      expression: "itemsInList !== user.data.length"
    }],
    staticClass: "beers-in-list"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.beersInList(_vm.user.data.length)
      }
    }
  }, [_vm._v("Visa alla")]), _vm._v("  \n            ")]), _vm._v(" "), (_vm.user.data.length > 10) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemsInList !== 10),
      expression: "itemsInList !== 10"
    }],
    staticClass: "beers-in-list"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.beersInList(10)
      }
    }
  }, [_vm._v("Topp 10")]), _vm._v("  \n            ")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemsInList !== 3),
      expression: "itemsInList !== 3"
    }],
    staticClass: "beers-in-list"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.beersInList(3)
      }
    }
  }, [_vm._v("Topp 3")])])] : _vm._e()], 2)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-49cb3865", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49cb3865"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/facts/UserBeers.vue
// module id = 151
// module chunks = 1